import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, RippleData } from '../types'

export const RippleWavesEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const thickness = 2
  const rippleColor = effectColors[0] || '#6366f1'

  const [ripples] = useState(() => {
    const rippleCount = 3
    const newRipples: Array<RippleData> = []
    for (let i = 0; i < rippleCount; i++) {
      newRipples.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        delay: Math.random() * 3,
      })
    }
    return newRipples
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {ripples.map((ripple) => (
        <div
          key={ripple.id}
          style={{
            position: 'absolute',
            left: `${ripple.x}%`,
            top: `${ripple.y}%`,
          }}
        >
          {[0, 1, 2].map((wave) => (
            <motion.div
              key={wave}
              style={{
                position: 'absolute',
                border: `${thickness}px solid ${rippleColor}`,
                opacity: opacityValue,
                borderRadius: '50%',
              }}
              initial={{
                width: 0,
                height: 0,
                x: 0,
                y: 0,
              }}
              animate={{
                width: [0, 400],
                height: [0, 400],
                x: [0, -200],
                y: [0, -200],
                opacity: [opacityValue, 0],
              }}
              transition={{
                duration: 4 * (100 / Math.max(effectSpeed, 1)),
                repeat: Infinity,
                ease: 'easeOut',
                delay: ripple.delay + wave * 0.5,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  )
})
RippleWavesEffect.displayName = 'RippleWavesEffect'
